<template>
    <!-- Root element of PhotoSwipe. Must have class pswp. -->
    <div id="pm-photoswipe" class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
        <!-- Background of PhotoSwipe.
         It's a separate element as animating opacity is faster than rgba(). -->
        <div class="pswp__bg" />

        <!-- Slides wrapper with overflow:hidden. -->
        <div class="pswp__scroll-wrap">
            <!-- Container that holds slides.
            PhotoSwipe keeps only 3 of them in the DOM to save memory.
            Don't modify these 3 pswp__item elements, data is added later on. -->
            <div class="pswp__container">
                <div class="pswp__item" />
                <div class="pswp__item" />
                <div class="pswp__item" />
            </div>

            <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
            <div class="pswp__ui pswp__ui--hidden" style="max-height: 0px; height: 0!important; overflow: hidden;">
                <div class="pswp__top-bar" :class="[$theme.toolbarBg]">
                    <div class="pswp__counter" style="display: none;"/>
                    <pm-application-bar style="position: absolute; z-index: 9999; color: #fff; padding: 0 16px;">
                        <v-icon @click.stop="close" class="gallery--button-back" style="color: #fff">chevron_left</v-icon>
                        {{ $t('photos.title') }}
                    </pm-application-bar>

                    <button class="pswp__button pswp__button--close" title="Close (Esc)" style="display: none;" />

                    <div class="pswp__preloader" style="display: none"></div>
                </div>


                <transition name="pm-fade-in-slide-down-transition">
                    <div v-show="!fullscreen" style="display: flex; align-items: center; justify-content: center; white-space: nowrap; overflow: hidden; border-bottom: 1px solid #f6f6f6; text-align: center; position: absolute; top: 57px; left: 0px; right: 0px; padding:10px 15px; box-shadow: 0 0 10px rgba(0,0,0,.08); background: #ebebeb; color: #000;" class="gallery--breadcrumb-title">
                        <template v-if="$router.currentRoute.name==='gallery-before-after'">
                            Case #{{ idx+1 }} - {{ title }}
                        </template>
                        <template v-else-if="$router.currentRoute.name==='gallery-favourites'">
                            <mdi size="18" style="flex-shrink: 0; flex-grow: 0; margin: 0 5px 0px 0;">heart-outline</mdi>
                            <span style="flex-shrink: 0; flex-grow: 0;" @click="close">{{ $t('photos.favourites') }}</span>
                        </template>
                        <template v-else>
                            <span @click="close" style="display: inline-block; max-width: 35vw; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{ galleryTitle }}</span>
                            <span style="padding: 0 10px; position: relative; top: -1px; display: inline-block;">&rarr;</span>
                            <span style="display: inline-block; max-width: 60vw; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; font-weight: bold" v-if="items[idx]">
                                <template v-if="favourites > idx">{{ $t('photos.favourites') }}</template>
                                <template v-else>{{ items[idx].tags[0] }}</template>
                            </span>
                        </template>
                    </div>
                </transition>

                <template v-if="isDev && items[idx]">
                    <div style="display: flex; align-items: center; justify-content: center; font-size: 14px!important; padding: 0 16px; height: 40px; line-height: 1.4;
                     color: #444!important; position: absolute; bottom: 160px; left: 20px; right: 20px; align-items: center; justify-content: center;">

                        <div style="padding: 4px 20px; border-radius: 32px; display: flex; align-items: center; justify-content: center; white-space: nowrap; background: rgba(248,248,248,1); x-ox-shadow: 0 0 20px rgba(0,0,0,.08); ">


                            <div style="font-size: 14px; font-weight: normal; max-width: Calc(100vw - 114px); text-align: center; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; flex-grow: 1">
                                {{ idx+1 }} - {{ items[idx].src }}
                            </div>
                        </div>
                    </div>
                </template>

                <div class="pswp__caption" style="display: block!important; text-align: center!important; height: 72px; background: #fff!important;"></div>
            </div>
        </div>

        <span @click="toggleThumbnails"
                v-show="!fullscreen"
              v-if="innerWidth >= 700"
              style="transition: bottom 0.65s; box-shadow: 0 0 10px rgba(0,0,0,.2); position: absolute; right: 20px; background: #fff; padding: 8px 15px; font-size: 10px;border-radius: 20px;"
        :style="showThumbnails ? 'bottom: 200px;' : 'bottom: 86px;'"
        >
            <template v-if="showThumbnails">HIDE THUMBNAILS</template>
            <template v-else>SHOW THUMBNAILS</template>
        </span>
        <transition name="pm-fade-in-slide-up-transition">
            <div class="pswp-thumbnail-scrollable-container" v-show="showThumbnails && !fullscreen">
                <div ref="thumbnails" class="pswp-thumbnail-scrollable" :style="{minWidth: items.length * 98 + 'px'}">
                    <template v-for="(item, i) in items">
                        <error-boundary>
                            <div :key="item.id + '-' + i" @click="goto(i)" :class="i === idx ? 'active' : ''" class="pswp-thumbnail-scrollable-thumb" :style="'background-image: url(\'https://cdn.denticalc.com/photos/'+ item.src.replace('.jpg', imageSrc) + '\')'">
                            </div>
                        </error-boundary>
                    </template>
                </div>
            </div>
        </transition>

        <div style="background: #011111!important; display: flex; align-items: center; line-height: 48px!important; position: absolute; top: 0px; left: 0; border: 0px solid #f00; right: 0; z-index: 9999; color: #fff; padding: 2px 15px 0 15px;">
            <pm-application-bar >
                <v-icon @click.stop="close" class="gallery--button-back" style="color: #fff">chevron_left</v-icon>
                {{ $t('photos.title') }}
            </pm-application-bar>

            <span @click.stop="fullscreen = !fullscreen" style="display: inline-block; margin-top: 3px; margin-bottom: -3px;">
                <mdi size="24" v-show="fullscreen" style="color: #fff;">mdiFullscreenExit</mdi>
                <mdi size="24" v-show="!fullscreen" style="color: #fff;">mdiFullscreen</mdi>
            </span>
        </div>

        <div :key="favved" @click.stop="toggleFavved" style="box-shadow: 0 0 20px rgba(0,0,0,.08); transition: top 0.3s; text-align: center; line-height: 40px; width: 40px; height: 40px; flex-grow: 0; position: absolute; left: 12px; border-radius: 50%; background: rgba(255,255,255,.85);" class="gallery--favourite-button"
            :style="!fullscreen ? 'top: 107px;' : 'top: 67px;'"
        >
            <mdi class="pink--text text--lighten-2" v-if="favved" :size="20">heart</mdi>
            <mdi class="grey--text text--darken-1" v-else :size="20">heart-outline</mdi>
        </div>

        <div style="box-shadow: 0 0 20px rgba(0,0,0,.08); transition: top 0.3s; text-align: center; line-height: 40px; width: 40px; height: 40px; flex-grow: 0; position: absolute; right: 12px; border-radius: 50%; background: rgba(255,255,255,.85);" class="gallery--close-button"
            :style="!fullscreen ? 'top: 107px;' : 'top: 67px;'"

        >
            <v-icon @click="close" >close</v-icon>
        </div>

        <div class="v-footer app-toolbar" style="position: absolute; bottom: 0; left: 0; right: 0; display: block!important; text-align: center!important; height: 72px; background: #fff!important;">

            <div class="app-toolbar app-toolbar--mobile app-toolbar-photos app-toolbar-4">
                <div @click="openGallery" class="app-toolbar-item" id="pm-toolbar-item--0" :class="$router.currentRoute.name==='gallery-page' ? 'app-toolbar-item--active' : ''">
                    <mdi>image-outline</mdi>
                    <span class="app-toolbar-btn-text roboto bold--text">{{ $t('photos.title') }}</span>
                </div>
                <div @click="openBeforeAfter" class="app-toolbar-item" id="pm-toolbar-item--1" :class="$router.currentRoute.name === 'gallery-before-after' ? 'app-toolbar-item--active' : ''">
                    <mdi>emoticon-happy-outline</mdi>
                    <span class="app-toolbar-btn-text roboto bold--text">{{ $t('photos.before_after') }}</span>
                </div>
                <div @click="openFavourites" class="app-toolbar-item" id="pm-toolbar-item--2" :class="$router.currentRoute.name === 'gallery-favourites' ? 'app-toolbar-item--active' : ''">
                    <mdi>heart-outline</mdi>
                    <span class="app-toolbar-btn-text roboto bold--text">{{ $t('photos.favourites') }}</span>
                </div>
                <div class="app-toolbar-item app-back-button-icon" @click="close">
                    <v-icon style="color: #000; font-size: 26px;">chevron_left</v-icon>
                </div>
            </div>

        </div>
    </div>
</template>

<style>
.pswp-thumbnail-scrollable {
    position: relative;
    height: 70px;
    display: flex;
    padding: 5px;
}
.pswp-thumbnail-scrollable-thumb {
    width: 66px; height: 60px; overflow: visible; background-size: cover; background-position: center center;
    position: relative;
    transition: all .1s;
    margin: 0 3px;
    z-index: 1;
    border-radius: 3px;
}
.pswp-thumbnail-scrollable-thumb.active {
    z-index: 2;
    width: 78px;
    height: 68px;
    margin: -4px 5px;
    border-radius: 3px;
    box-shadow: 0 0 10px rgba(0,0,0,.5);
}
.pswp-thumbnail-scrollable-container {
    position: fixed;
    bottom: 82px; width: 100vw; z-index: 1;
    height: 70px;
    background: none;
    overflow: scroll;
}
.pswp-thumbnail-scrollable-container::-webkit-scrollbar {
  width: 0px;
    height: 0px;
}
.pswp__top-bar, .pswp__button, .pswp__caption {
    opacity:1 !important;
}
.pswp__bg {
    background: #F8F8F8 !important;
}
#pm-photoswipe.pswp__ui--fit .pswp__top-bar, #pm-photoswipe.pswp__ui--fit .pswp__caption {
    background-color: rgba(255,255,255,.03)!important;
    color: #000!important;
}
.pswp__ui--fit .pswp__top-bar {
    background-color: #2979ff!important;
    height: 52px;
    padding-top: 4px;
}
.pswp__counter {
    padding-top: 4px;
}

.pswp__caption__center {
    color: #000!important;
    text-align: center;
}

.pswp__container_animated {
     transition:.3s ease-in-out all;
}
#pm-photoswipe {
    z-index: 5 !important;
}

.pswp-padded-img .pswp__img {
border: 15px transparent solid;
}

.pswp__img--placeholder {
    filter: blur(2px);
}

.gallery--button-back {
    margin-top: -3px;
    margin-right: 2px;
}

.pswp__top-bar {
    border-bottom: 5px solid #8dc243 !important;
    border-collapse: unset;
    max-height: 57px;
    height: 57px!important;
    overflow: hidden;
    display: flex;
    align-items: center;
    box-shadow: 0 0 10px rgba(0,0,0,.08);
}

@media (min-width: 700px) {
    .pswp-thumbnail-scrollable {
        height: 100px;
    }

    .gallery--button-back {
        margin-right: -1px;
    }

    .pswp__top-bar {
        height: 57px !important;
        max-height: 57px !important;
    }

    .pswp__top-bar span {
        font-size: 22px;
    }

    .pswp__top-bar span+span {
        font-size: 14px !important;
    }
    .pswp__top-bar div+span {
        font-size: 14px !important;
    }

    .pswp-thumbnail-scrollable,
    .pswp-thumbnail-scrollable-container {
        height: 116px;
    }

    .pswp-thumbnail-scrollable-container {
        bottom: 76px;
    }

    .pswp-thumbnail-scrollable-thumb {
        width: 98px !important;
        height: 96px !important;
    }

    .pswp-thumbnail-scrollable-thumb.active {
        width: 108px !important;
        height: 110px !important;
        margin: -5px 6px !important;
    }

    .gallery--favourite-button,
    .gallery--close-button {
        margin-top: 16px;
    }

    .gallery--favourite-button {
        transform: scale(1.2);
        margin-left: 12px;
    }

    .gallery--close-button {
        transform: scale(1.2);
        margin-right: 12px;
    }

    .gallery--breadcrumb-title {
        padding: 10px 15px !important;
        top: 58px !important;
        font-size: 18px;
    }
}
</style>

<script>
import PhotoSwipe from "photoswipe/dist/photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";
import galleryFavvedMixin from "@/components/gallery/mixin-method-favved";
import AdManager from "@/extensions/managers/ad-manager";
import ErrorBoundary from "@/components/core/error-boundary";

export default {
    components: {ErrorBoundary},
    mixins: [galleryFavvedMixin],
    data() {
        return({
            packageName: window.packageName,
            favved: false,
            items: [],
            idx: 0,
            title: "",
            galleryId: 0,
            categoryTitle: "",
            favToggled: false,
            welcomeSteps: [{
                title: 'Gestures',
                description: 'You can use various gestures to control the photo viewer.',
                img: '/images/welcome/gestures.png',
                imgStyle: 'max-width: 90%; margin-bottom: 30px;'
            }],
            favourites: 0,
            showThumbnails: false,
            params: {},
            isDev: (location.hostname.includes("test.app.")),
            innerWidth: window.innerWidth,
            fullscreen: false,
        });
    },
    computed: {
        is4in1() {
            const urlParams = new URLSearchParams(window.location.search);
            const packageName = urlParams.get('packageName');

            return packageName === 'com.denticalc.4in1';
        },
        imageSrc() {
            return document.body.getBoundingClientRect().width > 600
                ? '_thumb_guetzli.jpg'
                : '_thumb_xs_guetzli.jpg';
        },
    },
    activated() {
        this.close();
    },
    watch: {
        idx() {
            this.scrollToThumb(this.idx);

            const uniqueGalleryImageIdList = new Set(JSON.parse(localStorage.getItem('uniqueGalleryImageIdList') || '[]'));

            uniqueGalleryImageIdList.add(this.idx);
            localStorage.setItem('uniqueGalleryImageIdList', JSON.stringify([...uniqueGalleryImageIdList]));
        }
    },
    created() {
        this.registerBusEvent('networkStatusChange', status => {
            if (status === "online") {
                const index = this.gallery.getCurrentIndex();
                // destroy current gallery
                this.gallery.destroy();
                // create a new gallery
                this.params.start = index;
                this.init(this.params);
            }
        });
    },
    methods: {
        toggleThumbnails() {
            this.showThumbnails = !this.showThumbnails;
            localStorage.setItem('galleryShowThumbs', this.showThumbnails);
        },
        scrollToThumb(idx, smooth = true) {
            const el = document.querySelector('.pswp-thumbnail-scrollable-container');
            const w = document.body.clientWidth;
            const options = {
                top: 0,
                left: (idx * 66) - (w / 2) + 33,
            }
            if (smooth) options.behavior = 'smooth';
            el.scrollTo(options);
        },
        openGallery() {
            this.gallery.close();
            this.$emit('changeView', 'all');
        },
        openBeforeAfter() {
            this.gallery.close();
            this.$emit('changeView', 'before-after');
            // if (this.$router.currentRoute.path === "/gallery-before-after") this.gallery.close();
            // else this.$router.push("/gallery-before-after").catch(_ => {});
        },
        openFavourites() {
            this.gallery.close();
            this.$emit('changeView', 'favourites');
            // if (this.$router.currentRoute.path === "/gallery-favourites") this.gallery.close();
            // else this.$router.push("/gallery-favourites").catch(_ => {});
        },
        toggleFavved() {
            this.favved = !this.favved;
            this.toggleFavvedHandler('favvedGalleryMedia', this.settings.src);
            this.favToggled = true;
        },
        init(params) {
            // const isDev = (location.hostname === "localhost" || location.hostname.includes("192.168.0.") || location.hostname.includes("test.app."));
            this.isDev = false;

            const transitionMode = localStorage.getItem('transitionMode') || 'full';

            this.params = params;
            this.showThumbnails = false;
            if (localStorage.getItem('welcomeScreenPhotoswipeShown') === null) {
                this.firstRun = true;
                localStorage.setItem('welcomeScreenPhotoswipeShown', 1);
            } else {
                // AdManager.show('gallery');
            }

            if (params.categoryTitle === 'Before-after') {
                document.querySelector("#pm-photoswipe").classList.add('pswp-padded-img');
            }

            // if (window.packageName==='com.denticalc.4in1' && !this.$store.state.isPro && params.items.length > 3) {
            //     params.items = JSON.parse(JSON.stringify(params.items.slice(0, 3)));
            //     // params.start = 0;
            // }
            // if (window.packageName==='com.denticalc.4in1' && !this.$store.state.isPro) {
            //     params.items.push({
            //         src: "transparent.png",
            //         w:500,
            //         h:500,
            //         tags: [ "" ],
            //         title: { en: "" }
            //     });
            // }

            this.items = params.items;
            this.idx = params.start;
            //this.title = this.items[this.idx].title['en'];
            this.title = "";
            this.galleryId = params.galleryId;
            this.galleryTitle = params.galleryTitle;
            this.categoryTitle = params.categoryTitle;
            this.favved = this.isFavved('favvedGalleryMedia', this.items[this.idx].src);
            this.settings = this.items[this.idx];
            this.favourites = params.favourites ? params.favourites : 0;

            const baseUrl = "https://cdn.denticalc.com/photos/";
            const pswpElement = document.querySelectorAll(".pswp")[0];
            const imgs = [];

            this.items.forEach((item) => {
                imgs.push({
                    src: baseUrl + item.src.replace(".jpg", "_full_guetzli.jpg"),
                    msrc: baseUrl + item.src.replace(".jpg", "_thumb_xs_guetzli.jpg"),
                    title: item.title["en"],
                    w: item.width || 800,
                    h: item.height || 800,
                });
            });

            const barSizeMobile = {top: 32, bottom: 122};
            const barSizeTablet = {top: 48, bottom: 152};

            const options = {
                index: this.idx, // start at first slide
                errorMsg: '<div class="pswp__error-msg">' + this.$t('core.offline') + '</div>',
                barsSize: barSizeMobile,
                addCaptionHTMLFn: (item, captionEl, isFake) => {
                    this.title = item.title;
                    return true;
                },
                closeEl: false,
                captionEl: true,
                fullscreenEl: false,
                zoomEl: false,
                shareEl: false,
                counterEl: false,
                arrowEl: false,
                preloaderEl: true,
                preload: [1,3],
                tapToToggleControls: false,
                history: false,
                showAnimationDuration: transitionMode === 'full' ? 333 : 0,
                hideAnimationDuration: transitionMode === 'full' ? 333 : 0,
                allowPanToNext: transitionMode === 'full' ? true : false,
                pinchToClose: transitionMode === 'full' ? true : false,
                closeOnScroll: false,
                closeOnVerticalDrag: transitionMode === 'full' ? true : false,
                history: false,
                tapToClose: false
            };

            // Initializes and opens PhotoSwipe
            const gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, imgs, options);

            gallery.listen('beforeChange', () => {
                this.idx = gallery.getCurrentIndex();
                this.favved = this.isFavved('favvedGalleryMedia', this.items[this.idx].src);
                this.title = this.items[this.idx].title['en'];
                this.settings = this.items[this.idx];
                this.logView();

                // if (window.packageName==='com.denticalc.4in1' && !this.$store.state.isPro) {
                //     if (this.idx === 3) {
                //          this.$bus.$emit("free_trial:show", {
                //             countdown: 0,
                //             route: '/gallery',
                //         });
                //         window.setTimeout(() => {
                //             // https://github.com/dimsemenov/PhotoSwipe/issues/1326
                //             this.gallery.goTo(0);
                //         }, 500);
                //     }
                // }
            });

            gallery.listen('firstUpdate', function() {
                gallery.listen('parseVerticalMargin', function(item) {
                    item.vGap.top += 45;
                    item.vGap.bottom += 25;

                    if (window.innerHeight >= 1024 || window.innerWidth >= 1024) {
                        item.vGap.top += 45;
                        item.vGap.bottom += 25;
                    }
                });
            });

            gallery.listen('close', () => {
                if (this.favToggled = true) this.$emit('toggleFavved');
                this.favToggled = false;
            });

            gallery.init();

            this.gallery = gallery;
            this.logView();
            window.setTimeout(()=> {
                // https://stackoverflow.com/questions/44004622/how-to-get-horizontal-padding-in-photoswipe
                if (this.galleryTitle !== "Before-after") this.showThumbnails = window.innerWidth < 700 || localStorage.getItem('galleryShowThumbs') !== 'false';
                this.$nextTick(()=>{
                    this.scrollToThumb(this.idx, false);
                });
            }, 50);
        },
        logView() {
            let photoViews = localStorage.getItem('photoViews') || 0;
            photoViews++;
            localStorage.setItem('photoViews', photoViews);
        },
        close() {
            this.showThumbnails = false;
            if(typeof this.gallery!== "undefined" && typeof this.gallery.close === "function") {
                this.gallery.close();
            }
        },
        goto(idx) {
            if (this.slideAnimationTimeout) window.clearTimeout(this.slideAnimationTimeout);
            this.slideAnimationTimeout = window.setTimeout(() => {
                document.querySelector('.pswp__container').classList.remove('pswp__container_animated');
            }, 300);
            document.querySelector('.pswp__container').classList.add('pswp__container_animated');
            this.gallery.goTo(idx);
        },
        prev() {
            if (this.slideAnimationTimeout) window.clearTimeout(this.slideAnimationTimeout);
            this.slideAnimationTimeout = window.setTimeout(() => {
                document.querySelector('.pswp__container').classList.remove('pswp__container_animated');
            }, 300);
            document.querySelector('.pswp__container').classList.add('pswp__container_animated');
            this.gallery.prev();
        },
        next() {
            if (this.slideAnimationTimeout) window.clearTimeout(this.slideAnimationTimeout);
            this.slideAnimationTimeout = window.setTimeout(() => {
                document.querySelector('.pswp__container').classList.remove('pswp__container_animated');
            }, 300);
            document.querySelector('.pswp__container').classList.add('pswp__container_animated');
            this.gallery.next();
        },
    },
};
</script>
